import { render, staticRenderFns } from "./OrdersTimeline.vue?vue&type=template&id=813b5a5a&scoped=true"
import script from "./OrdersTimeline.vue?vue&type=script&lang=js"
export * from "./OrdersTimeline.vue?vue&type=script&lang=js"
import style0 from "./OrdersTimeline.vue?vue&type=style&index=0&id=813b5a5a&prod&lang=scss&scoped=true"
import style1 from "./OrdersTimeline.vue?vue&type=style&index=1&id=813b5a5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813b5a5a",
  null
  
)

/* custom blocks */
import block0 from "./OrdersTimeline.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports